import { useTokenPrice, UseTokenPriceResult } from './useTokenPrice';

export type UseSolPriceResult = UseTokenPriceResult;

export const useSolPrice = (): UseSolPriceResult => useTokenPrice('solPriceUpdate');
